














































































































































































































































































































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import InputGroup from '@/mixins/form/inputGroup'
import { PrivateWorker } from '@/types/user'
import { Occupation } from '@/types/user'

@Component({
  components: {
    TextInput: () => import('@/components/common/inputs/TextInput.vue'),
    NumberInput: () => import('@/components/common/inputs/NumberInput.vue'),
    SelectInput: () => import('@/components/common/inputs/SelectInput.vue')
  }
})
export default class WorkerInfoInputGroup extends mixins(InputGroup) {
  @Prop({ type: Object }) inputs!: PrivateWorker
  @Prop({ type: Array }) occupations!: Occupation[]

  get occupationOptions() {
    return this.occupations.map(({ code, name }) => ({
      text: name,
      value: code
    }))
  }
}
